export default "__VITE_ASSET__BLLi8ckl__"